<template>
  <div class="emd-loader" v-bind:class="type">
    <div></div>
    <div></div>
    <div></div>
  </div>
</template>
<script>
export default {
  name: 'EmdLoader',
  props: {
    type: {
      type: String,
      default: '',
      validator: function (value) {
        // O valor precisa corresponder a alguma dessas Strings
        return ['_invert', '_subtle', ''].indexOf(value) !== -1
      }
    }
  }
}
</script>
